const win = window;
export default function (options, responseInterceptors) {

    if (!options) {
        return;
    }

    const reloadMethod = function (response, error) {
        console.log(response);
        alert('You may have logged out. Redirecting to login page.');
        const location = win.location;
        console.log('Redirecting to ', location);
        win.location = location;
        return Promise.reject(error);
    };

    let ignoredURLs = options.ignoreUnAuthorisedErrorURLs || [];

    if (options.reloadOnUnAuthorised) {
        responseInterceptors.use(function (response) {
            return response;
        }, function (error) {
            const response = error.response;
            if (response.status === 401) {
                const url = error.config.url;
                if (ignoredURLs.indexOf(url) < 0) {
                    return reloadMethod(response, error);
                }
            }
            return Promise.reject(error);
        });
    }

    if (options.unAuthorisedError) {
        responseInterceptors.use(function (response) {
            return response;
        }, function (error) {
            const response = error.response;
            if (response.status === 401) {
                const url = error.config.url;
                if (ignoredURLs.indexOf(url) < 0) {
                    return options.unAuthorisedError(response);
                }
            }
            return Promise.reject(error);
        });
    }
}
